const forms = [
    {
        name: "Details",
        className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
        options: [
            {
                name: "Date",
                type: "date",
                form: {
                    type: "text",
                    name: "date",
                    placeholder: "Request date",
                    class: "",
                    value: "",
                    required: true,
                },
            },
            {
                name: "Site",
                type: "select",
                form: {
                    name: "site",
                    allowClear: true,
                    showSearch: true,
                    filterOption: false,
                    placeholder: "Select site",
                    api: "get-all-sites",
                    options: null,
                    value: null,
                    required: true,
                },
            },
            {
                name: "Requested By",
                type: "select",
                form: {
                    name: "requested_by",
                    allowClear: true,
                    showSearch: true,
                    filterOption: false,
                    placeholder: "Requested by",
                    api: "get-all-users",
                    options: null,
                    value: null,
                    required: true,
                },
            },
            {
                name: "Priority",
                type: "select",
                form: {
                    name: "priority",
                    allowClear: false,
                    placeholder: "Priority",
                    value: 0,
                    options: [
                        { value: 0, label: "Normal" },
                        { value: 1, label: "Urgent" },
                    ],
                    required: false,
                },
            },
            {
                name: "Notes",
                type: "input",
                form: {
                    type: "text",
                    name: "notes",
                    placeholder: "Notes",
                    class: "",
                    value: "",
                    required: false,
                },
            },
            {
                name: "Status",
                type: "select",
                form: {
                    name: "request_status",
                    allowClear: false,
                    placeholder: "Status",
                    value: 0,
                    options: [
                        { value: 0, label: "Draft" },
                        { value: 1, label: "Submitted" },
                    ],
                    required: false,
                },
            },
        ],
    },
];

export default forms;